<template>
    <div>
        <!-- SAVE CONFIG FORM -->
        <div v-if="app.auth.isLogged" class="d-flex flex-row align-items-center justify-content-center">
            <div class="col-12 col-md-8 mb-3">
                <div class="card">
                    <!-- TITLE -->
                    <div class="card-header">
                        <strong>{{ $t("s4_save_configuration") }}</strong>
                    </div>

                    <div class="card-body">
                        <!-- NAME -->
                        <div class="form-group">
                            <label for="exampleInputEmail1">{{
                                $t("s4_configuration_name")
                            }}</label>
                            <input
                                type="text"
                                class="form-control"
                                v-model="app.currentConfiguration.label"
                            />
                            <div
                                v-if="show_invalid_name_insuf_char"
                                class="alert alert-danger mt-2 mb-2"
                                role="alert"
                            >
                                {{ $t("s4_config_name_invalid_insuf_char") }}
                            </div>
                            <div
                                v-if="show_invalid_name_already_used"
                                class="alert alert-danger"
                                role="alert"
                            >
                                {{ $t("s4_config_name_repeated") }}
                            </div>
                        </div>

                        <!-- PROJECT -->
                        <div class="form-group">
                            <label for="projectSelect"
                                >{{ $t("s4_configuration_project") }}:</label
                            >

                            <div class="d-flex">
                                <!-- DROPDOWN EXISTING PROJECTS -->
                                <select
                                    id="projectSelect"
                                    class="custom-select"
                                    v-model="
                                        app.currentConfiguration.project_id
                                    "
                                    @change="changeProject()"
                                >
                                    <option selected :value="null">
                                        {{ $t("projects_no_project") }}
                                    </option>
                                    <option
                                        v-for="(project, index) in app.projects
                                            .list"
                                        :key="index"
                                        :value="project.id"
                                    >
                                        {{ project.label }}
                                    </option>
                                </select>
                                <button
                                    type="button"
                                    class="
                                        btn
                                        btn-outline-dark
                                        btn_rounded
                                        btn_desktop_size
                                        ml-2
                                        text-center
                                    "
                                    @click="app.projects.create(true)"
                                    :title="$t('projects_new_project')"
                                >
                                    <i class="fas fa-plus"></i>
                                </button>
                            </div>

                            <!-- DEBUG BUTTONS -->
                            <div
                                v-if="false"
                                class="d-flex justify-content-center mt-2"
                            >
                                <button
                                    type="button"
                                    class="btn btn-dark ml-2 text-center"
                                    @click="app.projects.create(true)"
                                >
                                    <i class="fas fa-plus"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-dark ml-2 text-center"
                                    :disabled="
                                        !app.currentConfiguration.projectId
                                    "
                                    @click="
                                        app.projects.update(
                                            app.currentConfiguration.projectId
                                        )
                                    "
                                >
                                    <i class="fas fa-edit"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-dark ml-2 text-center"
                                    :disabled="
                                        !app.currentConfiguration.projectId
                                    "
                                    @click="
                                        app.projects.remove(
                                            app.currentConfiguration.projectId
                                        )
                                    "
                                >
                                    <i class="fas fa-trash-alt"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-dark ml-2 text-center"
                                    v-show="false"
                                    @click="app.projects.refresh()"
                                >
                                    <i class="fas fa-undo"></i>
                                </button>
                            </div>
                        </div>

                        <!-- SAVE BUTTON -->
                        <button
                            type="button"
                            :disabled="!userIsLoggedIn"
                            class="btn btn-outline-secondary"
                            :class="
                                userIsLoggedIn ? 'enabled_btn' : 'disabled_btn'
                            "
                            @click="saveConfiguration"
                        >
                            <i
                                v-if="buttonLoading"
                                class="fa fa-spinner fa-spin mr-1"
                            ></i>
                            <i
                                v-if="buttonOK"
                                class="
                                    size_check_desktop
                                    fa-lg
                                    far
                                    fa-check-circle
                                    mr-1
                                "
                                style="color: black"
                            ></i>
                            {{ $t("s4_save_configuration") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- EXPORT CONFIG  -->
        <div v-if="app.auth.isLogged" class="d-flex flex-row align-items-center justify-content-center">
            <div class="col-12 col-md-8 mb-3">
                <div class="card">
                    <!-- TITLE -->
                    <div class="card-header">
                        <strong>{{ $t("s4_export_configuration") }}</strong>
                    </div>

                    <div class="card-body">
                        <img
                            :src="require('@/assets/images/results/pdf.png')"
                            @click="downloadPdf"
                            class="downloadBOMIcon raise"
                            :class="iconClass"
                            title="Pdf"
                            alt
                        />
                        <img
                            :src="require('@/assets/images/results/excel.png')"
                            @click="downloadExcel"
                            class="downloadBOMIcon raise"
                            :class="iconClass"
                            title="Excel"
                            alt
                        />

                        <i
                            @click="goToMyConfigs"
                            class="
                                downloadBOMIcon
                                raise
                                far
                                fa-folder fa-lg
                                d-none
                            "
                            title="My configurations"
                            style="
                                line-height: 1em;
                                font-size: 60px;
                                color: green;
                            "
                        ></i>
                        <!-- </div> -->
                    </div>
                </div>
            </div>
        </div>

        <div v-if="app.auth.isLogged && !app.WholeSaler.isWholeSaler" class="d-flex flex-row align-items-center justify-content-center">
            <div class="col-12 col-md-8">
                <div class="card">
                    <div class="card-body">
                        <button
                            type="button"
                            :disabled="!userIsLoggedIn"
                            class="btn btn-outline-secondary"
                            :class="
                                userIsLoggedIn ? 'enabled_btn' : 'disabled_btn'
                            "
                            @click="goToMyConfigs"
                        >
                            {{ $t("s4_my_configurations") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- ------------------- -->
        <!--    LOGIN ICON       -->
        <!-- ------------------- -->

        <div
            v-if="userIsLoggedIn"
            class="d-flex flex-column align-items-center justify-content-center"
        ></div>

        <!-- Wholesalers, no mostrem botó de login/registre -->
        <div
            v-else-if="!this.app.WholeSaler.isWholeSaler"
            class="
                d-flex
                flex-column
                align-items-center
                justify-content-center;
            "
        >
            <div @click="app.auth.login()">
                <img
                    :src="require('@/assets/images/results/login.png')"
                    class="loginIcon"
                />
                <button class="btn btn-secondary loginButton">
                    {{ $t("login_btn") }}
                </button>
            </div>

            <span class="ml-2" style="color: grey; font-size: 1em">{{
                $t("login_explanation")
            }}</span>
        </div>
    </div>
</template>

<style scoped lang="scss">
.btn_bottom {
    width: 225px;
    height: 38px;
}

$transparencyIcon: 0.5;
$transparencyContainer: 0.5;

.raise:hover,
.raise:focus {
    transform: translateY(-0.02em);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05),
        0 6px 20px 0 rgba(0, 0, 0, 0.05);
}

.containerItem {
    height: 180px;
}

.disabled_btn {
    cursor: not-allowed;
}

.enabled_btn {
    cursor: pointer;
}

.activeIcon {
    cursor: pointer !important;
}

.inactiveDiv {
    background: rgba(1, 1, 1, $transparencyContainer);
    cursor: not-allowed !important;
    z-index: 1;
}

.loginButton {
    margin: 5px;
}

.myConfigsButton {
    height: 48px;
}

.loginIcon {
    width: 50px;
    margin: 5px;
    height: auto;
}

.downloadBOMIcon {
    height: 70px;
    margin: 15px;
    width: auto;
}

.size_check_desktop {
    font-size: 1.25em;
    color: green;
}

.inactiveIcon {
    cursor: not-allowed;
    opacity: $transparencyIcon;
}

.iconsContainer {
    border: 1px solid grey;
    border-radius: 15px;
    margin: 10px;
    padding: 10px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.saveConfigContainer {
    // width: 300px;
    border: 1px solid grey;
    margin: 10px;
    padding: 10px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
}

.loginIconContainer {
    border-radius: 0px;
    margin: auto;
    padding: 10px;
}
</style>

<script>
import { app } from "../../application.js";

export default {
    name: "downloadsComponent",

    data() {
        return {
            app: app,
            buttonLoading: false,
            buttonOK: false,
            show_invalid_name_insuf_char: false,
            show_invalid_name_already_used: false,
            idgama: "",
            idsolucionconstructiva: ""
        };
    },

    created() {
        this.idgama =
            app.currentConfiguration.familyParameters["gama"].value.id;

        this.idsolucionconstructiva =
            app.currentConfiguration.familyParameters[
                "sol_constructiva"
            ].value.id;

        this.refreshProjects()
    },
    methods: {
        downloadPdf: async function () {
            if (this.userIsLoggedIn) {
                // await this.$parent.screenshot_images_mainElements();
                await this.app.getScreenshotMainElement()
                this.app.downloadBOM("pdf");
            }
        },
        downloadExcel: async function () {
            if (this.userIsLoggedIn) {
                // await this.$parent.screenshot_images_mainElements();
                await this.app.getScreenshotMainElement()
                this.app.downloadBOM("xlsx");
            }
        },
        goToMyConfigs: function () {
            if (this.userIsLoggedIn) {
                this.app.routerPush("myConfigs");
            }
        },
        async changeProject(){
            // Guardar canvi de projecte
            if( app.currentConfiguration.saved === true) {
                await this.saveConfiguration()
            }
        },
        saveConfiguration: async function () {
            var self = this;

            //comproba nom configuracio es correcte
            if (app.currentConfiguration.label.length < 6) {
                this.show_invalid_name_insuf_char = true;
                this.buttonOK = false;
                return;
            }

            this.show_invalid_name_insuf_char = false;

            //falta qan backend implementat comprobacio nom ja
            //existeix mostri show_invalid_name_already_used
            try {
                self.buttonLoading = true;
                self.buttonOK = false;
                // await this.$parent.screenshot_images_mainElements();
                await this.app.getScreenshotMainElement()
                await self.app.API.saveConfiguration();
                self.buttonLoading = false;
                self.buttonOK = true;
            } catch (error) {
                self.buttonLoading = false;
                self.buttonOK = false;
            }

        },
        showModalSelectionSendPdfExcelByMail: function () {
            if (this.userIsLoggedIn) {
                let self = this;
                let infoModal = {
                    modalToShow: "showExportBOM",
                    title: "Exportación BOM",
                    html_message: "",
                    message: "Selecciona cómo quieres enviar el BOM",
                    showConfirmationButton: true,
                    showCancelButton: false,
                    textConfirmationButton: "Si",
                    textCancelButton: "No"
                };

                self.app
                    .showModal(infoModal)
                    .then(({ userAction, paramResult }) => {
                        if (userAction === "modal_rejected") {
                            //do nothing
                        } else if (userAction === "modal_confirmed") {

                        }
                    });
            }
        },
        refreshProjects: async function () {
            await app.projects.refresh()
        }
    },
    computed: {
        userIsLoggedIn: function () {
            //console.log("app.auth.isLogged: ", app.auth.isLogged);
            return app.auth.isLogged;
        },

        iconClass: function () {
            return {
                activeIcon: this.userIsLoggedIn,
                inactiveIcon: !this.userIsLoggedIn
            };
        },
        divClass: function () {
            return {
                activeDiv: this.userIsLoggedIn,
                inactiveDiv: !this.userIsLoggedIn
                //activeDiv: true
            };
        }
    }
};
</script>




